
import React, { useMemo } from 'react';
import { Sidebar } from 'primereact/sidebar';

import '../../sanitary/micSampling/styleSidebarDiary.css';

export const SidebarDiary = ({
    sidebarVisible,
    closeSidebar,
    panelMode,
    selectedEvent,
    selectedDate,
    dayEvents = [],
    getEventData,
    formatDate,
    formatLongDate,
    openDetails,
    backToList,
    startSampling
}) => {


    const eventData = useMemo(() => {
        if (!selectedEvent) return null;

        return getEventData(selectedEvent);
    }, [selectedEvent, getEventData]);

    const customerAddress = useMemo(() => {
        if (!eventData) return '';

        return [
            eventData.address,
            eventData.colony || eventData.colony_name,
            eventData.cp
        ]
            .filter(value =>
                value !== null &&
                value !== undefined &&
                String(value).trim() !== ''
            )
            .join(', ');
    }, [eventData]);


    const hasValue = (value) => {
        return (
            value !== null &&
            value !== undefined &&
            String(value).trim() !== ''
        );
    };


    const renderField = (label, value, icon = null, className = '') => {
        if (!hasValue(value)) return null;

        return (
            <div
                className={`samplingSidebar-field ${className}`}
                key={label}
            >
                <div className="samplingSidebar-field-label">
                    <span>{label}</span>
                </div>

                <div className="samplingSidebar-field-value">
                    {value}
                </div>
            </div>
        );
    };

    const renderSection = (title, icon) => {
        return (
            <div className="samplingSidebar-section-heading">

                <div className="samplingSidebar-section-icon">
                    <i className={`fa ${icon}`} />
                </div>

                <h4>{title}</h4>

            </div>
        );
    };

    const renderHeader = () => {
        return (
            <div className="samplingSidebar-header">
                <div className="samplingSidebar-header-content">
                    <div className="samplingSidebar-header-icon">
                        <i
                            className={
                                panelMode === 'list'
                                    ? 'fa fa-calendar-check-o'
                                    : 'fa fa-flask'
                            }
                        />
                    </div>

                    <div className="samplingSidebar-header-text">

                        <h3>
                            {panelMode === 'list'
                                ? 'Muestreos del día'
                                : `Detalle del muestreo - ${eventData?.code || ''}`}
                        </h3>

                        <p>
                            {panelMode === 'list'
                                ? 'Consulta los muestreos programados'
                                : 'Información del muestreo seleccionado'}
                        </p>

                    </div>

                </div>

                <button
                    type="button"
                    className="samplingSidebar-close"
                    onClick={closeSidebar}
                    aria-label="Cerrar panel"
                    title="Cerrar"
                >
                    <i className="fa fa-times" />
                </button>

            </div>
        );
    };

    const renderDaySummary = () => {
        return (
            <div className="samplingSidebar-day-summary">

                <div className="samplingSidebar-day-icon">
                    <i className="fa fa-calendar" />
                </div>

                <div className="samplingSidebar-day-info">

                    <span>FECHA SELECCIONADA</span>

                    <strong>
                        {formatLongDate(selectedDate)}
                    </strong>

                </div>

                <div className="samplingSidebar-day-count">

                    <strong>{dayEvents.length}</strong>

                    <span>
                        {dayEvents.length === 1
                            ? 'Muestreo'
                            : 'Muestreos'}
                    </span>

                </div>

            </div>
        );
    };

    const renderDayEvent = (eventItem) => {

        const itemData = getEventData(eventItem) || {};
        const companyColor = itemData.companyColor || {};

        return (
            <button
                type="button"
                key={eventItem.id}
                className="samplingSidebar-event-card"
                onClick={() => openDetails(eventItem)}
                style={{
                    '--sidebar-event-color':
                        companyColor.border || '#1684c8',
                    '--sidebar-event-bg':
                        companyColor.bg || '#e7f2ff'
                }}
            >

                <div className="samplingSidebar-event-icon">
                    <i className="fa fa-flask" />
                </div>

                <div className="samplingSidebar-event-info">

                    <div className="samplingSidebar-event-code">
                        {itemData.code ||
                            eventItem.title ||
                            'Sin código'}
                    </div>

                    {hasValue(itemData.name_company) && (
                        <div className="samplingSidebar-event-company">
                            <i className="fa fa-building-o" />
                            <span>{itemData.name_company}</span>
                        </div>
                    )}

                    {hasValue(itemData.phone) && (
                        <div className="samplingSidebar-event-phone">
                            <i className="fa fa-phone" />
                            <span>{itemData.phone}</span>
                        </div>
                    )}

                </div>

                <div className="samplingSidebar-event-arrow">
                    <i className="fa fa-angle-right" />
                </div>

            </button>
        );
    };

    const renderEventList = () => {
        return (
            <div className="samplingSidebar-body">

                {renderDaySummary()}

                <div className="samplingSidebar-list-heading">

                    <h4>Muestreos programados</h4>

                    <p>
                        Selecciona un muestreo para consultar
                        su información.
                    </p>

                </div>

                {dayEvents.length > 0 ? (

                    <div className="samplingSidebar-event-list">

                        {dayEvents.map(eventItem =>
                            renderDayEvent(eventItem)
                        )}

                    </div>

                ) : (

                    <div className="samplingSidebar-empty">

                        <div className="samplingSidebar-empty-icon">
                            <i className="fa fa-calendar-o" />
                        </div>

                        <h4>Sin muestreos registrados</h4>

                        <p>
                            No hay muestreos programados
                            para la fecha seleccionada.
                        </p>

                    </div>

                )}

            </div>
        );
    };

    const renderCompanySummary = () => {

        if (!eventData) return null;

        return (
            <div className="samplingSidebar-company-card">

                <div className="samplingSidebar-company-icon">
                    <i className="fa fa-building-o" />
                </div>

                <div className="samplingSidebar-company-info">

                    <span>CLIENTE</span>

                    <h4>
                        {eventData.name_company ||
                            'Sin empresa registrada'}
                    </h4>

                </div>

            </div>
        );
    };

    const renderCustomerInformation = () => {

        if (!eventData) return null;

        const hasCustomerInformation =
            hasValue(eventData.name_company) ||
            hasValue(eventData.phone) ||
            hasValue(customerAddress);

        if (!hasCustomerInformation) return null;

        return (
            <section className="samplingSidebar-section samplingSidebar-customer-section">

                {renderSection(
                    'INFORMACIÓN DE CONTACTO',
                    'fa-user-o'
                )}

                <div className="samplingSidebar-fields">
                    {renderField(
                        'Dirección',
                        customerAddress,
                        'fa-map-marker'
                    )}

                    {renderField(
                        'Teléfono',
                        eventData.phone,
                        'fa-phone'
                    )}
                </div>

            </section>
        );
    };

    const renderSamplingInformation = () => {

        if (!eventData) return null;

        const samples = Array.isArray(eventData.list_samples)
            ? eventData.list_samples
            : [];

        const totalSamples = eventData.no_samples ?? samples.length;

        return (
            <section className="samplingSidebar-section">

                {renderSection(
                    'MUESTRAS Y ESTUDIOS',
                    'fa-flask'
                )}

                <div className="samplingSidebar-sampling-summary">

                    <div className="samplingSidebar-sampling-summary-info">
                        <span>Cantidad de muestras</span>

                        <strong>
                            {totalSamples}
                            {Number(totalSamples) === 1
                                ? ' muestra'
                                : ' muestras'}
                        </strong>
                    </div>

                    <div className="samplingSidebar-sampling-summary-icon">
                        <i className="fa fa-flask" />
                    </div>

                </div>

                {samples.length > 0 ? (
                    <div className="samplingSidebar-samples-list">
                        {samples.map((sample, index) => {

                            const determinations = Array.isArray(sample.list_determinations)
                                ? sample.list_determinations
                                : [];

                            return (
                                <div className="samplingSidebar-sample-card" key={sample.id_quoter_type_samples ?? index}>
                                    <div className="samplingSidebar-sample-header">
                                        <div className="samplingSidebar-sample-number">
                                            {String(index + 1).padStart(2, '0')}
                                        </div>

                                        <div className="samplingSidebar-sample-info">
                                            <strong>
                                                {sample.name_sample ||
                                                    'Muestra sin nombre'}
                                            </strong>

                                            {sample.folio && (
                                                <span>
                                                    <i className="fa fa-tag" />
                                                    {sample.folio}
                                                </span>
                                            )}
                                        </div>

                                        <div className="samplingSidebar-sample-count">
                                            {determinations.length}
                                            {determinations.length === 1
                                                ? ' estudio'
                                                : ' estudios'}
                                        </div>
                                    </div>

                                    <div className="samplingSidebar-sample-content">
                                        <div className="samplingSidebar-determinations-heading">
                                            Determinaciones asignadas
                                        </div>
                                        {determinations.length > 0 ? (
                                            <div className="samplingSidebar-determinations-list">
                                                {determinations.map(
                                                    (determination, determinationIndex) => (
                                                        <div className="samplingSidebar-determination-item" key={determination.id_quoter_determination ?? determinationIndex}>
                                                            <i className="fa fa-check-circle" />

                                                            <span>
                                                                {determination.name ||
                                                                    'Determinación sin nombre'}
                                                            </span>

                                                            {determination.id_profile != null && (
                                                                <span className="samplingSidebar-determination-type">
                                                                    Perfil
                                                                </span>
                                                            )}
                                                        </div>
                                                    )
                                                )}
                                            </div>
                                        ) : (
                                            <div className="samplingSidebar-determinations-empty">
                                                No hay determinaciones asignadas.
                                            </div>
                                        )}
                                    </div>
                                </div>
                            );
                        })}
                    </div>

                ) : (

                    <div className="samplingSidebar-samples-empty">
                        <i className="fa fa-info-circle" />
                        <span>
                            No hay muestras registradas para esta cotización.
                        </span>
                    </div>

                )}

            </section>
        );
    };

    const renderDetailActions = () => {

        return (
            <div className="samplingSidebar-actions">

                {dayEvents.length > 1 && (
                    <button
                        type="button"
                        className="samplingSidebar-button-secondary"
                        onClick={backToList}
                    >
                        <i className="fa fa-arrow-left" />
                        <span>Regresar al listado</span>
                    </button>
                )}

                <button
                    type="button"
                    className="samplingSidebar-button-primary"
                    onClick={startSampling}
                >
                    <i className="fa fa-play-circle" />
                    <span>Iniciar muestreo</span>
                </button>

            </div>
        );
    };


    const renderEventDetails = () => {

        if (!selectedEvent || !eventData) {
            return null;
        }

        return (
            <div className="samplingSidebar-detail-layout">

                <div className="samplingSidebar-body">
                    {renderCompanySummary()}
                    {renderCustomerInformation()}
                    {renderSamplingInformation()}
                    {/* {renderScheduleInformation()} */}

                </div>
                {renderDetailActions()}
            </div>
        );
    };

    return (
        <Sidebar
            visible={sidebarVisible}
            position="right"
            onHide={closeSidebar}
            showCloseIcon={false}
            modal
            blockScroll
            className="samplingSidebar container-global-zoom"
            style={{
                width: 'min(680px, 100vw)'
            }}
        >
            {renderHeader()}
            {panelMode === 'list' && renderEventList()}
            {panelMode === 'detail' && renderEventDetails()}
        </Sidebar>
    );
};
